import { Button, Select, Row, Col, message, Modal, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Pagination from '@/components/pagination';
import api from '@/api/customer';
import { defaultInfo } from '@/typings/allType';
import male from '@/assets/images/male@2x.png';
import female from '@/assets/images/female@2x.png';
import other from '@/assets/images/other@2x.png';
import publicMethod from '@/utils/publicMethod';
import ReviewList from '@/components/ReviewList';
const CustomerDetails = () => {
    const link = useNavigate();
    const [state, setState] = useState<any>({
        ratingInfo: {
            ratingScore: 0,
            totalRatingCount: 0,
        },
    });
    const [info, setInfo] = useState<any>({});
    const [tableData, setTableData] = useState<any[]>([]);
    const [metaData, setMetaData] = useState({
        activeTasks: '0',
        cancelledTasks: '0',
        completedTasks: '0',
        totalHistoryPayout: '0.00',
        totalUpcomingPayout: '0.00',
    });
    const [loading, setLoading] = useState(false);
    const [totalRecord, setTotalRecord] = useState(1);
    const [activeTag, setActiveTag] = useState(1);
    const [tableTab, setTableTab] = useState(1);
    const [accountModal, setAccountModal] = useState({ disable: false, open: false, id: '', type: 1 });
    const [listParams, setListParams] = useState<any>({
        pageNum: 1,
        pageSize: 10,
        customerId: '',
        taskState: 'active',
    });
    const handleChange = (value: string) => {
        console.log(`selected ${value}`);
        const pat = {
            customerId: state.customerId,
            isDisable: value === 'Inactive',
        };
        if (value === 'Inactive') {
            setAccountModal({ open: true, disable: true, id: state.customerId, type: 1 });
            return;
        }
        changeStuatus(pat);
    };
    const changeStuatus = async (pat: defaultInfo) => {
        try {
            await api.changeCustomerStatus({ ...pat });
            setState({ ...state, disabled: pat.isDisable });
            setAccountModal({ open: false, disable: false, id: '', type: 1 });
        } catch (error: any) {
            setState({ ...state, disabled: !pat.isDisable });
            message.error(error);
        }
    };
    const delCustomer = async (pat: defaultInfo) => {
        try {
            api.deleteCustomer({ ...pat });
            setAccountModal({ open: false, disable: false, id: '', type: 1 });
            link(-1);
        } catch (error: any) {
            message.error(error);
        }
    };
    const handlePageChange = prop => {
        if (activeTag === 1) {
            setListParams(state => ({ ...state, pageNum: prop }));
            getTaskList({ ...listParams, pageNum: prop });
        } else if (activeTag === 2) {
            setListParams(state => ({ ...state, pageNum: prop }));
            getRatingList({ ...listParams, pageNum: prop, targetId: listParams.customerId, ratingType: 'CUSTOMER' });
        } else {
            getPaymentList({
                ...listParams,
                pageNum: prop,
            });
        }
    };
    const changeTableTab = (key: number) => {
        setTableTab(key);
        setListParams(state => ({
            ...state,
            pageNum: 1,
            taskState: key === 1 || key === 4 ? 'active' : key === 2 || key === 5 ? 'completed' : 'cancelled',
        }));
        if (key < 4) {
            getTaskList({
                ...listParams,
                pageNum: 1,
                taskState: key === 1 ? 'active' : key === 2 ? 'completed' : 'cancelled',
            });
        } else {
            getPaymentList({
                ...listParams,
                pageNum: 1,
                taskState: key === 4 ? 'active' : 'completed',
            });
        }
    };
    const changeActiveTag = (key: number) => {
        setActiveTag(key);
        setTotalRecord(0);
        setListParams({ ...listParams, pageNum: 1, taskState: 'active' });
        if (key === 1) {
            getTaskList({ ...listParams, pageNum: 1, taskState: 'active' });
        } else if (key === 2) {
            getRatingList({ ...listParams, pageNum: 1, targetId: listParams.customerId, ratingType: 'CUSTOMER' });
        } else {
            setTableTab(4);
            getPaymentList({ ...listParams, pageNum: 1, taskState: 'active' });
        }
    };
    const getTaskList = async pat => {
        setLoading(true);
        try {
            const res = await api.getCustomerTaskList({ ...pat });
            const list = res.data.records.map(item => {
                return Object.assign(item, {
                    taskPublishTime: item.taskPublishTime ? window.utils.formatTimeMDY(item.taskPublishTime) : '-',
                    taskWorkTime: item.workStartTime
                        ? window.utils.formatWorkPeriod(
                              //   item.workStartDate,
                              item.workStartTime,
                              //   item.workEndDate,
                              item.workEndTime
                          )
                        : '-',
                });
            });
            setMetaData({ ...metaData, ...res.data.metaData });
            setTableData(list);
            setTotalRecord(+res.data.total);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const getRatingList = async pat => {
        setLoading(true);
        try {
            const res = await api.getCustomerRatingList({ ...pat });
            const list = res.data.records;
            setTableData(list);
            setTotalRecord(+res.data.total);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const getPaymentList = async pat => {
        setLoading(true);

        try {
            const res = await api.getCustomerPaymentrecordList({ ...pat });
            const list = res.data.records.map(item => {
                return Object.assign(item, {
                    taskWorkTime: item.workStartTime
                        ? window.utils.formatWorkPeriod(
                              //   item.workStartDate,
                              item.workStartTime,
                              //   item.workEndDate,
                              item.workEndTime
                          )
                        : '-',
                });
            });
            setTableData(list);
            setMetaData({ ...metaData, ...res.data.metaData });
            setTotalRecord(+res.data.total);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const getInfo = async customerId => {
        try {
            const res = await api.getCustomerInfo({ customerId });
            setState({ ...state, ...res.data });
        } catch (error: any) {
            message.error(error);
        }
    };
    useEffect(() => {
        const info = JSON.parse(window.sessionStorage.getItem('customerInfo') ?? '{}');
        if (info.customerId) {
            getInfo(info.customerId);
            getTaskList({
                ...listParams,
                pageNum: 1,
                customerId: info.customerId,
                taskState: tableTab === 1 ? 'active' : tableTab === 2 ? 'completed' : 'cancelled',
            });
            setListParams(state => ({
                ...state,
                customerId: info.customerId,
                taskState: tableTab === 1 ? 'active' : tableTab === 2 ? 'completed' : 'cancelled',
            }));
            setInfo({ ...info });
        }
    }, []);
    return (
        <div className="page-main customer-details">
            <div className="page-title flex-between">
                <div>
                    <img
                        className="back-icon"
                        src={require('@/assets/images/back-icon.png')}
                        alt="back-icon"
                        onClick={() => {
                            link(-1);
                        }}
                    />
                    Customer Details <span className="customer-name">({info.fullName ?? '-'})</span>
                </div>
                <Button
                    className="delete-btn"
                    danger
                    onClick={() => {
                        setAccountModal({
                            disable: false,
                            open: true,
                            id: state.customerId,
                            type: 2,
                        });
                    }}
                >
                    Delete
                </Button>
            </div>
            {loading ? (
                <div className="data_loading flex-center">
                    <Spin />
                </div>
            ) : (
                <>
                    <div className="customer-tags">
                        <div
                            className={activeTag === 1 ? 'customer-tag customer-tag-active' : 'customer-tag'}
                            onClick={() => {
                                changeActiveTag(1);
                            }}
                        >
                            Identity information
                        </div>
                        <div
                            className={activeTag === 2 ? 'customer-tag customer-tag-active' : 'customer-tag'}
                            onClick={() => {
                                changeActiveTag(2);
                            }}
                        >
                            Reviews
                        </div>
                        <div
                            className={activeTag === 3 ? 'customer-tag customer-tag-active' : 'customer-tag'}
                            onClick={() => {
                                changeActiveTag(3);
                            }}
                        >
                            Payout information
                        </div>
                    </div>
                    {activeTag === 1 ? (
                        <div className="customer-card">
                            <div className="customer-info">
                                <div className="customer-avatar">
                                    <img src={info.avatarUrl ? info.avatarUrl : ''} alt="" />
                                </div>
                                <div className="customer-base">
                                    <div className="customer-name">
                                        {info.fullName ?? '-'}
                                        <img
                                            src={+state.gender === 1 ? male : +state.gender === 2 ? female : other}
                                            className="gender_icon"
                                            style={{ marginLeft: 8 }}
                                            alt=""
                                        />
                                        <div className="customer-status">
                                            <Select
                                                className={
                                                    state.disabled
                                                        ? 'select-input select-disable'
                                                        : 'select-input select-enable'
                                                }
                                                defaultValue="Active"
                                                style={{ width: 88 }}
                                                onChange={val => {
                                                    handleChange(val);
                                                }}
                                                value={state.disabled ? 'Inactive' : 'Active'}
                                                options={[
                                                    { value: 'Active', label: 'Active' },
                                                    { value: 'Inactive', label: 'Inactive' },
                                                ]}
                                                suffixIcon={
                                                    <img
                                                        src={require('@/assets/images/selected.png')}
                                                        style={{ width: 16, height: 16 }}
                                                    />
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="customer-star" onClick={() => changeActiveTag(2)}>
                                        <img src={require('@/assets/images/star.png')} alt="" />
                                        {state.ratingInfo.ratingScore ?? 0}{' '}
                                        <span>({state.ratingInfo.totalRatingCount ?? '0'})</span>
                                    </div>
                                    <div className="customer-email">
                                        Email Address: <span>{info.email}</span>
                                    </div>
                                    <div className="customer-mobile">
                                        Mobile Number: <span>{info.mobile}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : activeTag === 3 ? (
                        <div className="page-total">
                            <div className="total-item total-item-c" style={{ flex: 'unset', padding: 20, rowGap: 12 }}>
                                Total Upcoming Payout
                                <span>
                                    $
                                    {metaData.totalUpcomingPayout
                                        ? publicMethod.formatPrice(metaData.totalUpcomingPayout)
                                        : '0.00'}
                                </span>
                            </div>
                            <div className="total-item total-item-c" style={{ flex: 'unset', padding: 20, rowGap: 12 }}>
                                Total History Payout
                                <span>
                                    $
                                    {metaData.totalHistoryPayout
                                        ? publicMethod.formatPrice(metaData.totalHistoryPayout)
                                        : '0.00'}
                                </span>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {activeTag === 1 ? (
                        <div className="table">
                            <div className="tabs-table">
                                <div
                                    className={
                                        tableTab === 1 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(1);
                                    }}
                                >
                                    Active tasks ({metaData.activeTasks})
                                </div>
                                <div
                                    className={
                                        tableTab === 2 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(2);
                                    }}
                                >
                                    Completed tasks ({metaData.completedTasks})
                                </div>
                                <div
                                    className={
                                        tableTab === 3 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(3);
                                    }}
                                >
                                    Cancelled tasks ({metaData.cancelledTasks})
                                </div>
                            </div>

                            {totalRecord ? (
                                <>
                                    <div className="table-th">
                                        <Row>
                                            <Col span={5}>Task</Col>
                                            <Col span={4}>Tasker</Col>
                                            <Col span={3}>Category</Col>
                                            <Col span={4}>Task Value</Col>
                                            <Col span={4}>Posted Date</Col>
                                            <Col span={4}>Task Date</Col>
                                        </Row>
                                    </div>
                                    {tableData.map((item, index) => (
                                        <Row className="table-tr" key={index}>
                                            <Col span={5}>
                                                <div
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        window.sessionStorage.setItem(
                                                            'taskInfo',
                                                            JSON.stringify({
                                                                userId: info.customerId,
                                                                taskId: item.taskId,
                                                            })
                                                        );
                                                        link(`/task/detail?type=${window.btoa('customer')}`);
                                                    }}
                                                >
                                                    {item.taskTitle}
                                                    <div className="desc_tip two-line-text">{item.taskDescription}</div>
                                                </div>
                                            </Col>
                                            <Col span={4}>{(item || {})?.tasker?.fullName ?? '-'}</Col>
                                            <Col span={3}>{(item || {}).taskCategory.categoryName ?? '-'}</Col>
                                            <Col span={4}>
                                                {item.actualRemunerationAmount
                                                    ? `$${publicMethod.formatPrice(item.actualRemunerationAmount)}`
                                                    : '-'}
                                            </Col>
                                            <Col span={4}>{item.taskPublishTime}</Col>
                                            <Col span={4}>{item.taskWorkTime}</Col>
                                        </Row>
                                    ))}
                                    <Pagination
                                        total={totalRecord}
                                        pageChange={handlePageChange}
                                        pageNo={listParams.pageNum}
                                    />
                                </>
                            ) : (
                                <div className="no-data flex-center">No data</div>
                            )}
                        </div>
                    ) : activeTag === 2 ? (
                        totalRecord ? (
                            <>
                                <ReviewList tableData={tableData} />
                                <Pagination
                                    total={totalRecord}
                                    pageChange={handlePageChange}
                                    pageNo={listParams.pageNum}
                                />
                            </>
                        ) : (
                            <div className="no-data flex-center">No data</div>
                        )
                    ) : (
                        <div className="table">
                            <div className="tabs-table" style={{ margin: '24px 0' }}>
                                <div
                                    className={
                                        tableTab === 4 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(4);
                                    }}
                                >
                                    Upcoming payout
                                </div>
                                <div
                                    className={
                                        tableTab === 5 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        changeTableTab(5);
                                    }}
                                >
                                    History payout
                                </div>
                            </div>
                            {tableData.length ? (
                                <>
                                    {tableData.map((item, i) => {
                                        return (
                                            <div className="payout-item" key={`payment-item${i}`}>
                                                <Row>
                                                    <Col span={5}>
                                                        <div className="item-name">
                                                            {item.taskTitle}
                                                            {tableTab === 5 && !item.paidToTaskerTime ? (
                                                                <div
                                                                    className="Pending-pay"
                                                                    style={{ display: 'inline-block', marginLeft: 8 }}
                                                                >
                                                                    Pending
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                        <div className="item-content two-line-text">
                                                            {item.taskDescription ?? '-'}
                                                        </div>
                                                    </Col>
                                                    <Col span={3}></Col>
                                                    <Col span={7}>
                                                        <img
                                                            className="col-icon"
                                                            src={require('@/assets/images/calendar-t.png')}
                                                            alt=""
                                                        />
                                                        {item.taskWorkTime ?? '-'}
                                                    </Col>
                                                    <Col span={4}>
                                                        <img
                                                            className="col-icon"
                                                            src={require('@/assets/images/Amount.png')}
                                                            alt=""
                                                        />
                                                        $
                                                        {item.actualRemunerationAmount
                                                            ? publicMethod.formatPrice(item.actualRemunerationAmount)
                                                            : '0.00'}
                                                    </Col>
                                                    <Col span={5}>
                                                        <div className="done-by">
                                                            <img
                                                                src={
                                                                    item?.tasker.avatarUrl ? item.tasker.avatarUrl : ''
                                                                }
                                                                alt=""
                                                            />
                                                            <div>
                                                                Done by{' '}
                                                                <span>
                                                                    {item?.tasker.fullName ? item.tasker.fullName : ''}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        );
                                    })}
                                    <Pagination
                                        total={totalRecord}
                                        pageChange={handlePageChange}
                                        pageNo={listParams.pageNum}
                                    />
                                </>
                            ) : (
                                <div className="no-data flex-center">No data</div>
                            )}
                        </div>
                    )}
                </>
            )}
            <Modal width={560} maskClosable={false} centered={true} open={accountModal.open} closeIcon={<></>}>
                <div className="modal-title">{accountModal.type === 1 ? 'Disabled account' : 'Delete account'}</div>
                <div className="modal-tip tip-font-20">
                    {accountModal.type === 1
                        ? 'Are you sure you want to disable this account?'
                        : 'Are you sure you want to delete this account?'}
                </div>
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button
                        className="submit-btn"
                        onClick={() => {
                            setAccountModal({ disable: false, open: false, id: '', type: 1 });
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="submit-btn"
                        type="primary"
                        onClick={() => {
                            accountModal.type === 1
                                ? changeStuatus({
                                      customerId: accountModal.id,
                                      isDisable: true,
                                  })
                                : delCustomer({ customerId: accountModal.id });
                        }}
                    >
                        {accountModal.type === 1 ? 'Yes' : 'Yes, delete'}
                    </Button>
                </div>
            </Modal>
        </div>
    );
};
export default CustomerDetails;
